// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandlerDiscreteParameter,
    HasOnError,
    HasOnSuccess,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { UpdateAccountApiParameter } from "@insite/client-framework/Services/AccountService";
import {
    chain,
    GetCurrentAccount,
    UpdateSession,
} from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SaveCurrentAccount";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    HasOnSuccess & HasOnError<string>,
    UpdateAccountApiParameter,
    AccountModel,
    { account: AccountModel }
>;

const xGetCurrentAccount: HandlerType = props => {
    const state = props.getState();
    const {
        pages: {
            accountSettings: { editingAccount },
        },
    } = state;
    const updatedAccount = (state as any).xAccount;

    if (!editingAccount) {
        throw new Error("There was no current account when we are trying to save the current account");
    }

    props.account = updatedAccount
        ? {
              ...editingAccount,
              firstName: updatedAccount.firstName,
              lastName: updatedAccount.lastName,
              properties: {
                  ...editingAccount.properties,
                  company: updatedAccount.company,
                  jobTitle: updatedAccount.jobTitle,
                  phone: updatedAccount.phone,
                  //   xng-change: we need to send this flag as true always to get the data updated,
                  //   if not it will not update the account settings info in DB
                  fromAccountSettings: "true",
              },
          }
        : editingAccount;
};

const xUpdateSession: HandlerType = props => {
    props.dispatch({
        type: "Context/CompleteLoadSession",
        session: {
            ...props.getState().context.session,
            email: props.apiResult.email,
            userName: props.apiResult.userName,
        },
    });

    props.dispatch({
        type: "xAccountSettings/Update",
        properties: {
            resetPasswordRequired: props.apiResult?.properties?.resetPasswordRequired,
        },
    } as any);
};

replaceInChain(chain, GetCurrentAccount, xGetCurrentAccount);
replaceInChain(chain, UpdateSession, xUpdateSession);
